import React from "react";
import { css, cx } from "emotion";
import { defaultStyle } from "./style";

const SwitchForm = ({ label, checked, onChange, hasError, dataAction }) => {
	return (
		<div
			className={cx(
				css`
					${defaultStyle}
				`,
				"switch-form-component",
				{ "has-error": hasError },
				{ "switch-form-checked": !!checked }
			)}
			data-action={!!checked ? dataAction : undefined}
		>
			<input
				id="switch-form-flat"
				className="switch-form switch-form--flat"
				type="checkbox"
				checked={checked}
				readOnly={true}
			/>
			<label htmlFor="switch-form-flat" onClick={() => onChange(!checked)} />
			<strong className="switch-form-label" onClick={() => onChange(!checked)}>
				{label}
			</strong>
		</div>
	);
};

export default SwitchForm;
